module.exports = __webpack_public_path__ + "img/voucher_qf.55454598.svg";